 <template>
    <v-container fluid>
        <v-card>
          <v-toolbar>
            <v-icon>business_center</v-icon>
            <v-toolbar-title class="font-weight-light">Manejo de Venta de Cartera</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                  <v-icon v-if="action.esFrecuente">favorite</v-icon>
                  <v-icon v-else>favorite_border</v-icon>
                </v-btn>
              </template>
              <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
              <span v-else>Agregar a Tareas Frecuentes</span>  
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-row>
                <v-col cols ="3">
                    <v-autocomplete v-model="filtro.empresaId" :items="empresas" autocomplete="disabled"
                        item-text="nombre" item-value="id" label="De la Empresa:" placeholder="Seleccione una" ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                      <v-autocomplete v-model="filtro.tipoVentaCarteraId" :items="listTiposVentaCartera"
                          item-text="descripcion" item-value="id" label="Tipo:" placeholder="Seleccione uno"></v-autocomplete>
                </v-col>
                <v-col cols="3">
                      <v-autocomplete v-model="filtro.tipoEstadoId" :items="listTiposEstadoVentaCartera"
                          item-text="descripcion" item-value="id" label="Estado:" placeholder="Seleccione uno"></v-autocomplete>
                </v-col>
                <v-col cols="3">
                    <app-selector-periodos v-on:update-periodo="filtro.periodo = $event" :column='true'></app-selector-periodos>    
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="3">
                    <v-autocomplete v-model="filtro.inversorId" :items="listInversores"
                          item-text="nombre" item-value="id" label="Inversor:" placeholder="Seleccione uno"></v-autocomplete>
                </v-col>
               
                <v-spacer></v-spacer>
                <v-col cols="3">
                    <v-btn color="success" @click="getItems(true)">Traer Casos</v-btn>
                </v-col>
            </v-row>
            
            <v-flex>
                <v-card >
                  <v-toolbar  :color="$store.state.UiColors.crudToolbarList">
                    <v-icon>list</v-icon>
                    <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
                  </v-toolbar>
                
                  <v-data-table dense
                    :headers="headers"
                    :items="records"
                    :server-items-length="totalItems"
                    :rows-per-page="pagination.rowsPerPage"                      
                    :options.sync ="pagination"
                    v-model="selectedRow"
                    :loading="loading"  
                    class="elevation-1"
                    :footer-props="footer"
                    item-key="id"
                  >
                  <template v-slot:no-data>
                    <v-alert v-if="!primeraBusquedaRealizada" :value="true" color="grey lighten-3" icon="info">
                      Ingrese los filtros para realizar la búsqueda
                    </v-alert>
                    <v-alert v-else :value="true" color="grey" icon="warning">
                      No se encontraron datos
                    </v-alert>
                  </template>

                  <!-- <template v-slot:item="{ item,isSelected, select }"> -->
                  <template v-slot:item="{ item }">
                    <tr>
                    <!-- <tr  :key="item.id"  @click="selectRow(item)" :class="{'selectedRow': item === selectedRow[0] && !accionesMasivas}"> -->
                      
                      <!-- <td v-if="accionesMasivas==true"><v-simple-checkbox class="caption" color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox></td> -->
                      
                      <!-- <td><app-acciones-comunes :personaId="item.personaId"  > </app-acciones-comunes></td> -->
                      <td>
                        <v-speed-dial direction="right" :open-on-hover='true' >
                          <template v-slot:activator >
                            <v-btn slot="activator" color="orange" fab text small>
                              <v-icon color="orange" >touch_app</v-icon>                                
                            </v-btn>
                          </template>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="blue" v-on="on" @click="verDetalle(item)">
                                <v-icon>remove_red_eye</v-icon>
                              </v-btn>
                            </template>
                            <span>Ver Detalle</span>
                          </v-tooltip>

                          <v-tooltip v-if="item.estado != 'Anulada'" bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="error" v-on="on" @click="cambiarEstado(item, 4)">
                                <v-icon>cancel</v-icon>
                              </v-btn>
                            </template>
                            <span>Anular</span>
                          </v-tooltip>

                          <v-tooltip v-if="item.estado == 'Marcada'" bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="success" v-on="on" @click="cambiarEstado(item, 2)">
                                <v-icon>attach_money</v-icon>
                              </v-btn>
                            </template>
                            <span>Vender</span>
                          </v-tooltip>

                          <v-tooltip v-if="item.estado == 'Vendida'" bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn fab dark small color="indigo" v-on="on" @click="cambiarEstado(item, 3)">
                                <v-icon>done_all</v-icon>
                              </v-btn>
                            </template>
                            <span>Confirmar</span>
                          </v-tooltip>
                        </v-speed-dial>
                      </td>
                      <td class="text-xs-left caption">{{ item.nombre }}</td>
                      <td class="text-xs-left caption">{{ item.tipo }}</td>
                      <td class="text-xs-left caption">{{ item.numero }}</td>
                      <td class="text-xs-left caption"> {{ item.fechaAlta | dateParse('YYYY-MM-DD') | dateFormat('DD-MM-YYYY')}}</td>
                      <td class="text-xs-left caption">{{ item.importe | currency }}</td>
                      <td class="text-xs-left caption">{{ item.inversor }}</td>
                      <td class="text-xs-left caption">{{ item.estado}}</td>
                      <td class="text-xs-left caption"><v-chip small :color="item.empresaColor" label dark>{{item.empresaShort}}</v-chip></td>
                    </tr>
                  </template>
                  </v-data-table>
                </v-card >
            </v-flex>

            <v-divider></v-divider>
          </v-card-text>
          <v-card-actions>
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-btn @click.stop="altaVentaCartera()" color="brown" dark>  Dar de Alta una Venta de Cartera</v-btn> &nbsp;
                </v-col>
                
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card >

        <v-dialog v-model="showDetalle" persistent width="1000">
            <detalle-venta-cartera :ventaCarteraId="selectedVentaCarteraId" :show="showDetalle" @close-dialog="showDetalle=false"> </detalle-venta-cartera>
        </v-dialog>

        <template v-if="$store.state.debugModeOn">
          Debug Info: <p></p>
          
          Model: {{filtro}}<p></p>                              
          {{selectedRow}}  <p></p>                            
        </template>
    </v-container>
      
</template>

<style scoped>
.selectedRow {
    background-color: greenyellow;
    font-weight: bold;
}
</style>

<script>

import DetalleVentaCartera from '@/components/ventacartera/DetalleVentaCartera.vue'
import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
  components: {
    'detalle-venta-cartera': DetalleVentaCartera
  },
  data() {
    return {
      primeraBusquedaRealizada:false,
      loading: false,
      suspend: false,
      filterChanged:false,
      search: '', // valor para búsqueda
      pagination: { // definición de paginación
        sortDesc:[true],
        sortBy:[''],
        page: 1,
        itemsPerPage: 5
      },
      footer:{        
        showFirstLastPage: true,
        itemsPerPageOptions:[5,10,20, 50]
      },
      totalItems: 0, // va afuera de pagination 
      headers: [ // definición de columnas
        { text: 'Ver', value: 'accion', width:80, sortable:false },
        { text: 'Nombre', value: 'nombre'},
        { text: 'Tipo', value: 'tipo'},
        { text: 'Numero', value: 'numero'},
        { text: 'Fecha', value: 'fechaAlta', width: 130},
        { text: 'Importe', value: 'importe', width: 130},
        { text: 'Inversor', value: 'inversor'},
        { text: 'Estado', value: 'estado'},
        { text: 'Empresa', value: 'empresa'}
      ],
      records: [], // registros
      selectedRow: [],
      filtro: {empresaId:0,inversorId:0, tipoEstadoId:0, tipoVentaCarteraId:0, periodo:{id:1}},
      empresas: [],
      listInversores:[],
      listTiposVentaCartera:[],
      listTiposEstadoVentaCartera:[],
      showDetalle: false,
      selectedVentaCarteraId: ''
    };
  },
  async created() {   
      this.loadEmpresas();
      this.loadInversores();
      this.loadTiposVentaCartera();
      this.loadTiposEstadoVentaCartera();
  },  
  watch: {
    pagination :{
        handler(){
          if(this.primeraBusquedaRealizada)
            this.getItems(false);
        },
        deep: true
    },
    search() {
        this.getItems(true);
    },
    'activeTask':function(){
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if(this.closeRelatedTasks)
      {
          this.getItems(false);
      }
    }
  },
  computed: {
    ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
    action: function(){
      return this.getActionFromLink(this.$route.path) 
    },
  },
  methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError","setReporteActivo"]),
    ...mapActions(['setStatusTareaFrecuente']),
    selectRow (item) {
      if(this.selectedRow[0] === item)
      {
        this.selectedRow.pop();
      }
      else
      {
        this.selectedRow.pop();
        this.selectedRow.push(item);
      }
    },    
    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if(resetPagination)
      {
        this.pagination.page = 1
      }

      this.loading = true
      this.$validator.reset()
      
      let filter = this.filtro;

      try {
        var result = await http.get('ventasCartera?empresaId='+filter.empresaId + '&fechaDesde=' + filter.periodo.desde + '&fechaHasta=' + filter.periodo.hasta 
                                    + '&tipoId=' + filter.tipoVentaCarteraId + '&estadoId=' + filter.tipoEstadoId + '&inversorId=' + filter.inversorId  
                                    + '&limit='+this.pagination.itemsPerPage+'&page='+this.pagination.page 
                                    + '&sortby='+this.pagination.sortBy+'&descending='+(this.pagination.sortDesc.length > 0 ? this.pagination.sortDesc : 'false') );
        
        this.records = result.list;
        
        this.totalItems = result.totalCount
      } catch (error) {
        // Error
        this.alertError(error)
      }
      this.primeraBusquedaRealizada = true
      this.loading = false
    },
    async loadEmpresas(){
      this.loading = true;
      try{
        var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

        this.empresas = result.list;
        this.empresas.unshift({id:0,nombre:'(Todas)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadInversores(){
      this.loading = true;
      try{
        var result = await http.get('inversores');

        this.listInversores = result.list;
        this.listInversores.unshift({id:0,nombre:'(Todos)'});
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadTiposVentaCartera(){
        this.loading = true;
        try{
            var result = await http.get('tiposventacartera');

            this.listTiposVentaCartera = result.list;

            this.listTiposVentaCartera.unshift({id:0,descripcion:'(Todos)'});
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadTiposEstadoVentaCartera(){
        this.loading = true;
        try{
            var result = await http.get('tiposestadoventacartera');

            this.listTiposEstadoVentaCartera = result.list;

            this.listTiposEstadoVentaCartera.unshift({id:0,descripcion:'(Todos)'});
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    altaVentaCartera(){
      var params = {
          width:1200,
          visible: true
      };

      this.setActiveTask({task:'alta-venta-cartera', props: params})
    },
    verDetalle(venta){
      this.selectedVentaCarteraId = venta.id;
      this.showDetalle = true;

    },
    async cambiarEstado(venta,nuevoEstadoId)
    {
      if(confirm('¿Desea confirmar el cambio de estado de la venta ' + venta.nombre + '?'))
      {
        this.loading = true;
        try{
            var params = {};
            params.ventaCarteraId = venta.id;
            params.nuevoEstadoId = nuevoEstadoId;
            params.comentarios = '';

            var result = await http.post('ventasCartera/cambiarEstado',JSON.stringify( {parametros:  params} ));

            Vue.$log.debug(result);
            this.alertSuccess('Se modificó el estado de la venta exitosamente.');

            this.getItems(false);
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
      }
    }
  }
}
</script>